module.exports = __webpack_public_path__ + "static/Exam-720307f7022d3901bc64c80fc610acab.svg";